import React from 'react';
import { motion } from 'framer-motion';
import { ShimmerButton } from '../../ui/shimmer-button';
import { Input } from '../../ui/input';
import { Loader2, Key } from 'lucide-react';

export const ApiKeyQueryCard = ({
  apikey,
  setAPIKey,
  handleSearch,
  loading,
  greetingText
}) => {
  return {
    
    className: "col-span-2 row-span-2 group relative overflow-hidden",
    background: (
      <div className="absolute inset-0 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-600">
       
      </div>
    ),
    children: (
      
      <div className="relative z-20 h-full flex flex-col justify-between p-6 sm:p-8">
        {/* 顶部标签 */}
        <div className="text-gray-500 dark:text-gray-400 text-sm font-medium tracking-wider uppercase">
          SmallAi Key 查询
        </div>
        
        {/* 主标题区域 - 用问候语替代"额度查询" */}
        <div className="flex-1 flex flex-col justify-center mb-6">
          <div className="space-y-2 mb-6">
            {/* 问候语作为主标题 */}
            <motion.h1 
              className="text-gray-800 dark:text-gray-200 text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              {greetingText || '👋 欢迎'}
            </motion.h1>
            <motion.h3 
              className="text-gray-400 dark:text-gray-300 text-base sm:text-lg lg:text-xl font-medium leading-relaxed"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
            >
              输入你的 SmallAi Key
            </motion.h3>
          </div>
          
          {/* API Key 输入区域 */}
          <div className="space-y-4 w-full">
            <div className="relative">
              {/* 图标 */}
              <div className="absolute left-3 top-1/2 transform -translate-y-1/2 z-10">
                <Key className="h-4 w-4 text-muted-foreground" />
              </div>
              
              {/* 输入框 */}
              <Input
                value={apikey}
                onChange={(e) => setAPIKey(e.target.value)}
                placeholder="输入API令牌 (sk-...)"
                className="w-full pl-10 h-12 backdrop-blur-sm bg-white/70 dark:bg-gray-800/70 border-white/30 dark:border-gray-700/30 rounded-xl"
                onKeyDown={(e) => e.key === 'Enter' && !loading && handleSearch()}
                disabled={loading}
              />
            </div>
          </div>
        </div>
        
        {/* 底部查询按钮 */}
        <ShimmerButton
          onClick={handleSearch}
          disabled={loading}
          className="w-full shadow-2xl disabled:opacity-50 disabled:cursor-not-allowed"
          shimmerColor="#ffffff"
          shimmerDuration="3s"
          borderRadius="1rem"
          background="rgba(0, 0, 0, 1)"
        >
          {loading ? (
            <span className="flex items-center gap-2">
              <Loader2 className="h-5 w-5 animate-spin" />
              查询中...
            </span>
          ) : (
            <span className="whitespace-pre-wrap text-center text-sm font-medium leading-none tracking-tight text-white dark:from-white dark:to-slate-900/10 lg:text-lg">
              开始查询
            </span>
          )}
        </ShimmerButton>
      </div>
    ),
  };
};